import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Meals() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 0 40px 0",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 12,
            }}
          >
            Meals
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#333",
              marginBottom: 32,
            }}
          >
            Delicious meal recipes to try at home.
          </p>
          <ImageWithFallback
            src="/potato-curry.jpg"
            alt="Potato Curry"
            className="recipe-image-anim"
            style={{
              width: 340,
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 24,
            }}
          />
          <div
            style={{
              fontSize: "1.1rem",
              color: "#555",
              maxWidth: 600,
              textAlign: "center",
            }}
          >
            Explore a variety of home-cooked meals, from classic curries to
            creative new dishes. Click on a meal to see the full recipe!
          </div>
        </section>
        <section
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 48,
            margin: "40px 0 80px 0",
            flexWrap: "wrap",
          }}
        >
          <a
            href="/potato-curry"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/potato-curry.jpg"
                alt="Potato Curry"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Potato Curry
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                A classic Indian comfort food.
              </p>
              <span className="season-badge season-winter" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>❄️ Winter</span>
            </div>
          </a>
          <a
            href="/mushroom-curry"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/mushroom-curry.jpg"
                alt="Mushroom Curry"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Mushroom Curry
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                Rich, creamy, and full of flavor.
              </p>
              <span className="season-badge season-monsoon" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>🌧️ Monsoon</span>
            </div>
          </a>
          <Link
            to="/velvety_white_bean_tomato_stew"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/Velvety_white_bean_and_tomato_stew.jpg"
                alt="Velvety White Bean and Tomato Stew"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Velvety White Bean and Tomato Stew
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                A hearty stew perfect for a cozy evening.
              </p>
              <span className="season-badge season-winter" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>❄️ Winter</span>
            </div>
          </Link>
          <Link to="/puff" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/puff.jpg"
                alt="Puff Pastry Delight"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Puff Pastry Delight
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                A flaky and buttery puff pastry filled with your favorite ingredients.
              </p>
              <span className="season-badge season-fall" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>🍂 Fall</span>
            </div>
          </Link>
          <Link to="/tofu-wrap" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/tofu_wrap.jpg"
                alt="Tofu Wrap"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Tofu Wrap
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                A healthy and protein-packed wrap with seasoned tofu and fresh vegetables.
              </p>
              <span className="season-badge season-spring" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>🌸 Spring</span>
            </div>
          </Link>
          <Link to="/banana-pancakes" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/banana_pancakes.jpg"
                alt="Banana Pancakes"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Banana Pancakes
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                Fluffy pancakes made with ripe bananas, perfect for a sweet breakfast.
              </p>
              <span className="season-badge season-fall" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>🍂 Fall</span>
            </div>
          </Link>
          <Link to="/mix-vegetable-curry" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/mix_vegetable_curry.jpg"
                alt="Mix Vegetable Curry"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Mix Vegetable Curry
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                A colorful medley of vegetables in aromatic spices and flavorful gravy.
              </p>
              <span className="season-badge season-winter" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>❄️ Winter</span>
            </div>
          </Link>
          <Link to="/chilli-butter-pasta" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              className="recipe-card-anim"
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 260,
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <ImageWithFallback
                src="/buttered_pasta.png"
                alt="Chilli Butter Pasta"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 16,
                  borderRadius: 12,
                }}
              />
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                }}
              >
                Chilli Butter Pasta
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#444",
                }}
              >
                Spicy and buttery pasta with garlic and chilies. Quick, easy, and delicious!
              </p>
              <span className="season-badge season-winter" style={{ padding: "4px 12px", fontSize: "0.8rem", marginTop: 8, marginBottom: 0 }}>❄️ Winter</span>
            </div>
          </Link>
        </section>
      </main>
    </>
  );
}

export default Meals;